/**
 * 
 */

import { createWebHashHistory, createRouter, RouteRecordRaw } from "vue-router";
import Select from "@/components/Select.vue";
import ResultsTab from "@/components/ResultsTab.vue";
import SpeciesSpotlight from "@/components/SpeciesSpotlight.vue";
import HabitatSpotlight from "@/components/HabitatSpotlight.vue";
import Species from "@/components/Species.vue";
import Features from "@/components/Features.vue";
import People from "@/components/People.vue";
import Coastal from "@/components/Coastal.vue";
import Flags from "@/components/Flags.vue";
import SeafloorFeatures from "@/components/SeafloorFeatures.vue";
import FeaturesSummary from "@/components/FeaturesSummary.vue";
import DataQuality from "@/components/DataQuality.vue";
import EcoregionSummary from "@/components/EcoregionSummary.vue";
import SpeciesSummary from "@/components/SpeciesSummary.vue";
import Fish from "@/components/Fish.vue";
import Mammals from "@/components/Mammals.vue";
import Birds from "@/components/Birds.vue";
import Turtles from "@/components/Turtles.vue";
import Corals from "@/components/Corals.vue";
import CommunitiesAtSea from "@/components/CommunitiesAtSea.vue";
import Management from "@/components/Management.vue";
import OtherActivity from "@/components/OtherActivity.vue";
import CoastalSummary from "@/components/CoastalSummary.vue";
import CoastalHabitats from "@/components/CoastalHabitats.vue";
import CoastalHabitatCharacteristics from "@/components/CoastalHabitatCharacteristics.vue";
import CoastalBirds from "@/components/CoastalBirds.vue";
import CoastalOpps from "@/components/CoastalOpps.vue";
import SpeciesDataConsiderations from "@/components/SpeciesDataConsiderations.vue";
import PeopleDataConsiderations from "@/components/PeopleDataConsiderations.vue";
import FeaturesDataConsiderations from "@/components/FeaturesDataConsiderations.vue";
import CoastalDataConsiderations from "@/components/CoastalDataConsiderations.vue";
import PeopleSummary from "@/components/PeopleSummary.vue";
import Restoration from "@/components/Restoration.vue";
import CoastalThreats from "@/components/CoastalThreats.vue";

const featuresChildren: Array<RouteRecordRaw> = [
  {
    path: 'summary',
    component: FeaturesSummary,
    props: true
  },
  {
    path: 'seafloor',
    component: SeafloorFeatures,
    props: true
  },
  {
    path: 'data',
    component: FeaturesDataConsiderations,
    props: true
  }
  
]

const speciesChildren: Array<RouteRecordRaw> = [
  {    
    path: 'summary',
    component: SpeciesSummary,
    props: true
  },
  {    
    path: 'fish',
    component: Fish,
    props: true
  },
  {    
    path: 'mammals',
    component: Mammals,
    props: true
  },
  {    
    path: 'birds',
    component: Birds,
    props: true
  },
  {
    path: 'coastalbirds',
    component: CoastalBirds,
    props: true
  },
  {    
    path: 'turtles',
    component: Turtles,
    props: true
  },
  // {    
  //   path: 'corals',
  //   component: Corals,
  //   props: true
  // },
  {
    path: 'data',
    component: SpeciesDataConsiderations,
    props: true
  },
  {
    path: 'ecoregion1',
    component: EcoregionSummary,
    props: true
  },
  {
    path: 'ecoregion2',
    component: EcoregionSummary,
    props: true
  }
]

const coastalChildren: Array<RouteRecordRaw> = [
  {
    path: 'summary',
    component: CoastalSummary,
    props: true
  },
  {
    path: 'habitats',
    component: CoastalHabitatCharacteristics,
    props: true
  },
  {
    path: 'opps',
    component: CoastalOpps,
    props: true
  },
  {
    path: 'data',
    component: CoastalDataConsiderations,
    props: true
  },
  {
    path: 'restoration',
    component: Restoration,
    props: true
  },
  {
    path: 'threats',
    component: CoastalThreats,
    props: true
  },
  {
    path: 'ecoregion1',
    component: EcoregionSummary,
    props: true
  },
  {
    path: 'ecoregion2',
    component: EcoregionSummary,
    props: true
  }
]

const peopleChildren: Array<RouteRecordRaw> = [
  {
    path: 'summary',
    component: PeopleSummary,
    props: true
  },
  {
    path: 'cas',
    component: CommunitiesAtSea,
    props: true
  },
  {
    path: 'other',
    component: OtherActivity,
    props: true
  },
  {
    path: 'data',
    component: PeopleDataConsiderations,
    props: true
  }
]

const resultChildren: Array<RouteRecordRaw> = [
  {
    path: 'species',
    component: Species,
    children: speciesChildren
  },
  {
    path: 'features',
    component: Features,
    children: featuresChildren
  },
  {
    path: 'people',
    component: People,
    children: peopleChildren
  },
  {
    path: 'coastal',
    component: Coastal,
    children: coastalChildren
  },
  {
    path: 'summary',
    component: Flags
  }
]

const routes: Array<RouteRecordRaw> = [

  {
    path: "/select",
    name: "Select",
    component: Select,
  }, 
  {
    path: "/results:version(\\d+)",
    name: "Results",
    props: (route) => ({ version: Number(route.params.version) }),
    component: ResultsTab,
    children:resultChildren
  },
  {
    path: "/spSpotlight",
    name: "SpeciesSpotlight",
    component: SpeciesSpotlight,
  },
    {
    path: "/habSpotlight",
    name: "HabitatSpotlight",
    component: HabitatSpotlight,
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
